<template>
  <div class="knowledge-graph-container">
    <div class="message-info">
      <img
        class="avatar"
        src="@/assets/icons/zstp.png"
        alt="AI"
      />
      <div class="resource-title">知识图谱</div>
      <div class="switch-buttons">
        <div class="switch-button left" @click="prevChapter">
          <img :src="leftActive ? leftClickImg : leftImg" @mousedown="leftActive = true" @mouseup="leftActive = false" />
        </div>
        <div class="switch-button right" @click="nextChapter">
          <img :src="rightActive ? rightClickImg : rightImg" @mousedown="rightActive = true" @mouseup="rightActive = false" />
        </div>
      </div>
    </div>
    <!-- 左侧切换按钮 -->


    <!-- 图谱主体 -->
    <RelationGraph ref="graphRef" :options="graphOptions" :on-node-click="onNodeClick" style="width: 100%; height: 400px"/>

    <!-- 右侧切换按钮 -->

  </div>
</template>

<script>
  import RelationGraph from 'relation-graph'
  import graphData from '@/assets/data/graphList_combined_chapters.json'
  import rightImg from '@/assets/icons/arrow-right.png'
  import rightClickImg from '@/assets/icons/arrow-right-hover.png'
  import leftImg from '@/assets/icons/arrow-left.png'
  import leftClickImg from '@/assets/icons/arrow-left-hover.png'

  export default {
    name: 'KnowledgeGraph',
    components: { RelationGraph },
    data() {
      return {
        graphOptions: {
          debug: false,
          "layout": {
            label: '树',
            layoutName: 'tree',
            layoutClassName: 'seeks-layout-center',
            from: 'left',
            // 通过这4个属性来调整 tree-层级距离&节点距离
            min_per_width: 120,
            max_per_width: 120,
            min_per_height: 50,
            max_per_height: 250,
          },
          defaultExpandHolderPosition: 'right',
          defaultNodeShape:  1,
          defaultNodeWidth: 100,
          defaultLineShape:  4,
          defaultNodeBorderWidth: 0,
          defaultLineColor: '#bbb',
          defaultNodeColor: '#fff'
        },
        chapterIndex: 0,
        chapterList: graphData || [],
        leftImg,
        leftClickImg,
        rightImg,
        rightClickImg,
        leftActive: false,
        rightActive: false
      }
    },
    mounted() {
      this.loadGraph()
    },
    methods: {
      loadGraph() {
        const chapter = this.chapterList[0]
        if (!chapter || !chapter.rootId || !chapter.nodes[this.chapterIndex]) return

        // 计算节点深度并设置颜色
        const coloredNodes = this.assignDepthColors(chapter.nodes[this.chapterIndex])
        let nodes = [];
        nodes.push(coloredNodes);
        this.$nextTick(() => {
          this.$refs.graphRef.setJsonData(
            {
              rootId: chapter.rootId,
              nodes: nodes,
              lines: chapter.lines || []
            },
            () => {
              console.log('图谱加载完成:', chapter.name)
              //this.onChangeOptionByCase1(); // 强制刷新布局
              /*this.$refs.graphRef.setViewSize(300,600,0.8)*/
            }
          )
        })
      },
      onChangeOptionByCase1() {
        this.graphOptions.layout.min_per_width = 10;
        this.graphOptions.layout.max_per_width = 60;
        this.graphOptions.layout.min_per_height = 40;
        this.graphOptions.layout.max_per_height = 50;
        this.$refs.graphRef.setOptions(this.graphOptions, (graphInstance) => {
          // 这些写上当图谱初始化完成后需要执行的代码
          console.log('setOptions:callback:', graphInstance);
          // seeksRGGraph.refresh()
        });
      },
      assignDepthColors(nodes) {
        const colorPalette = ['#00c0ff', '#32d3a7', '#ffa940', '#ff6b81', '#a377ff', '#6dc8ec', '#85cf40']

        const assign = (node, depth = 0) => {
          const color = colorPalette[depth % colorPalette.length]
          node.color = color
          if (Array.isArray(node.children)) {
            node.children.forEach(child => assign(child, depth + 1))
          }
        }

        if (!nodes._visited) {
          assign(nodes)
          nodes._visited = true
        }

        return nodes
      },
      prevChapter() {
        if (this.chapterIndex > 0) {
          this.chapterIndex--
          this.loadGraph()
        }
      },
      nextChapter() {
        if (this.chapterIndex < this.chapterList.length - 1) {
          this.chapterIndex++
          this.loadGraph()
        }
      },
      onNodeClick(nodeObject, $event) {
        // 将点击的节点的 text 传递到父组件
        this.$emit('tag-click', nodeObject.text);
      }
    }
  }
</script>

<style scoped>
  .knowledge-graph-container {
    margin: 10px;
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06); /* 卡片投影 */
    height: 460px;
  }

  .switch-button {
    cursor: pointer;
    margin-left: 10px;
  }
  .switch-button img {
    width: 100%;
    height: auto;
  }

  .message-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px; /* 头像与名字间距 */
  }

  .avatar {
    width: 25px;
    height: 25px;
  }

  .resource-title {
    width: 100%;
    font-size: 19px;
    font-weight: 400;
    color: #4d565f;
  }

  .switch-buttons {
    display: flex;
    align-items: center;
    gap: 5px; /* 左右按钮间距 */
  }

  .switch-button {
    cursor: pointer;
    margin-left: 0; /* 移除原有左边距 */
  }
</style>



// WEBPACK FOOTER //
// src/components/ai/KnowledgeGraph.vue